import { ModuleType } from 'i18next';
import ddt from '@wix/da-ddt';
import blockedKeysData from './blocked-i18n-keys.json';

const BLOCKED_FLAG = 'babel_inactive_keys';

type BlockedProjectKeys = {
  project?: string;
  keys?: string[];
};

let blockedKeysSet: Set<string> | null = null;
let blockedProjectsByKey = new Map<string, string[]>();
const alertedKeys = new Set<string>();

const unusedKeyBlocker = {
  name: 'unusedKeyBlocker',
  type: 'postProcessor' as ModuleType,
  process(value: string, key: string[]) {
    if (!blockedKeysSet) return value;
    const firstKey = key[0];
    if (blockedKeysSet.has(firstKey)) {
      if (!alertedKeys.has(firstKey)) {
        alertedKeys.add(firstKey);
        const projects = blockedProjectsByKey.get(firstKey) || [];
        ddt.alert(
          'i18n-unused-key',
          `Blocked i18n key rendered: ${firstKey}`,
          ['i18n', 'unused-key-audit'],
          {
            key: firstKey,
            project: projects[0] || '',
            projects,
          }
        );
        // Mirror in console logs for easy browser-side verification.
        ddt.log('translation', `Blocked i18n key rendered: ${firstKey}`, {
          key: firstKey,
          project: projects[0] || '',
          projects,
        });
      }
    }
    return value;
  },
};

function setupUnusedKeyBlocking(flags?: string[] | null) {
  blockedKeysSet = null;
  blockedProjectsByKey = new Map<string, string[]>();
  alertedKeys.clear();

  if (!flags || !flags.includes(BLOCKED_FLAG)) {
    return;
  }

  const entries = Array.isArray(blockedKeysData)
    ? blockedKeysData
    : [blockedKeysData];
  const keysSet = new Set<string>();

  for (const entry of entries as BlockedProjectKeys[]) {
    const project = entry.project || 'all';
    const keys = Array.isArray(entry.keys) ? entry.keys : [];
    for (const blockedKey of keys) {
      keysSet.add(blockedKey);
      const existingProjects = blockedProjectsByKey.get(blockedKey) || [];
      if (!existingProjects.includes(project)) {
        blockedProjectsByKey.set(blockedKey, [...existingProjects, project]);
      }
    }
  }

  if (keysSet.size > 0) {
    blockedKeysSet = keysSet;
    ddt.log(
      'translation',
      `Unused key blocking ACTIVE: ${blockedKeysSet.size} keys blocked across ${entries.length} project buckets`
    );
  }
}

export default unusedKeyBlocker;
export { setupUnusedKeyBlocking };
